<template>
  <header class="header-shadow app-header">
    <div class="container container-main pt-[14px] pb-[10px] flex justify-between items-center">
      <router-link
        v-if="theme === 'default'"
        :to="{ name: '/home' }"
        class="block xl:mr-[24px] xl:mx-0 xl:shrink-0"
      >
        <figure>
          <img loading="lazy" src="/img/logo/logo-green.svg" alt="logo" class="w-[93px] md:w-[142px]" />
        </figure>
      </router-link>
      <LoginHeaderKids v-else />
      <div v-show="$route.meta.withHeaderNav">
        <CheckoutHeaderNav />
      </div>
    </div>
  </header>
  <main class="main--empty">
    <slot></slot>
  </main>
</template>

<script setup>
import CheckoutHeaderNav from "@/components/checkout/CheckoutHeaderNav.vue"
import LoginHeaderKids from "@/components/login/LoginHeaderKids.vue"
import { theme } from "@/services/getSiteTheme"
</script>

<style lang="scss" scoped>
.app-header {
  background: var(--color-cream);
}

.header-shadow {
  @media (min-width: 768px) {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  }
}
</style>
